export const VendorPaymentFileConstants = {
    statusImportedLower: "imported",
    statusProcessed: "Processed",
    statusProcessedLower: "processed",
    fileExtensionXlsx: ".xlsx",
    defaultErrorMessage: "Something went wrong!!!",
    pageTitle: "Payment Files",
    dateFormatApi: "YYYY-MM-DD",
    dateFormatDisplay: "MM/DD/YYYY",
    dateTimeFormatDisplay: "MM/DD/YYYY hh:mm A",
    downloadFallbackFileName: "payment-file.xlsx"
} as const;

export const VendorPaymentFileMessages = {
    onlyXlsxFileAllowed: "Only .xlsx file is allowed.",
    selectXlsxFile: "Please select a .xlsx file.",
    uploadedFileNotFoundToImport: "Uploaded file not found. Please upload the file again.",
    importReviewSuccess: "File records imported for review.",
    noPreviewRowsToSave: "No preview records found to save.",
    uploadedFileRequiredToSave: "Uploaded file is required to save records.",
    saveConfirmTitle: "Do you want to save payment file data?",
    saveSuccess: "Payment file saved successfully.",
    downloadSuccess: "File downloaded."
} as const;
